module.exports = __webpack_public_path__ + "img/img6.12efbb93.png";